export * from "./CurrencyNairaIconSolid";
export * from "./CurrencyNairaIcon";
